// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"36882c9c","211":"8021fe62","279":"040359f5","290":"668cbd3f","317":"83de1390","688":"c3a55607","695":"61794d09","706":"0780dd81","875":"8182af39","877":"a7369273","938":"6a303cc4"}[chunkId] + ".chunk.js";
};